import { render } from "./EditorDiscardDialog.vue?vue&type=template&id=528cf6e0&ts=true"
import script from "./EditorDiscardDialog.vue?vue&type=script&lang=ts"
export * from "./EditorDiscardDialog.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__